/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
import { get, isEmpty, isNil } from 'lodash-es';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectUser } from 'containers/User/selectors';
import LoadingScreen from '../../components/LoadingIndicator';
import { fetchStatus } from '../Appointment/actions';
import makeSelectAppointment from '../Appointment/selectors';
import makeSelectMembership from '../Membership/selectors';
import PageNotAllowed from '../../components/ErrorBoundary/page-not-allowed';
import { NOT_ALLOWED_ROUTES_IMPERSONATE_USER } from '../../utils/common';

function shouldHoldForFreshStatus(props) {
  if (!props.refreshStatus) return false;
  if (localStorage.getItem('impersonateUser') === 'true') return false;
  return Boolean(get(props, 'user.userData.id'));
}

function statusRouteKey(props) {
  return `${props.path || ''}|${get(props, 'computedMatch.url') || ''}`;
}

class EligibleRoute extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      routeKey: statusRouteKey(props),
      awaitingStatus: shouldHoldForFreshStatus(props),
      baselineRequestId: get(props, 'appointmentData.statusRequestId') || 0,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const routeKey = statusRouteKey(props);
    const requestId = get(props, 'appointmentData.statusRequestId') || 0;
    const { fetchingStatus, fetchingStatusError } = props.appointmentData;

    if (shouldHoldForFreshStatus(props) && routeKey !== state.routeKey) {
      return {
        routeKey,
        awaitingStatus: true,
        baselineRequestId: requestId,
      };
    }

    if (
      state.awaitingStatus &&
      requestId > state.baselineRequestId &&
      !fetchingStatus &&
      !fetchingStatusError
    ) {
      return { awaitingStatus: false };
    }

    return null;
  }

  componentDidMount() {
    if (this.state.awaitingStatus) {
      this.props.fetchStatus(null, 'default');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const routeChanged =
      prevState.routeKey !== this.state.routeKey ||
      statusRouteKey(prevProps) !== statusRouteKey(this.props);
    if (routeChanged && this.state.awaitingStatus) {
      this.props.fetchStatus(null, 'default');
    }
  }

  render() {
    const {
      // eslint-disable-next-line no-shadow
      component: Component,
      user: { fetching, userData },
      location,
      appointmentData: { myStatus, fetchingStatus },
      computedMatch,
      // membershipData: { membershipDetails },
      ...rest
    } = this.props; // eslint-disable-line react/prop-types

    const isImpersonateUser = isNil(localStorage.getItem('impersonateUser'))
      ? false
      : localStorage.getItem('impersonateUser') === 'true';

    const hasPendingActions =
      !fetchingStatus && myStatus && myStatus.pendingAppointmentActions;
    const match = computedMatch || this.props.match;
    const propsData = { ...this.props, match };
    const untippedAppointments =
      hasPendingActions &&
      hasPendingActions.filter(
        i => (Number(i.hasTip) === 0 && !isEmpty(i.therapist) ? i : null),
      );

    const unReviewedAppointments =
      hasPendingActions &&
      hasPendingActions.filter(
        i => (Number(i.hasReview) === 0 && !isEmpty(i.therapist) ? i : null),
      );

    const paymentFailedAppointments =
      !fetchingStatus && myStatus && myStatus.hasFailedAppointments;

    const hasMembershipPaymentFailed =
      !fetchingStatus && myStatus && myStatus.hasFailedMembership;

    const requireLiabilityForm =
      !fetchingStatus && myStatus && myStatus.requireLiabilityForm;

    const requirePreferences =
      !fetchingStatus && myStatus && myStatus.requirePreferences;

    const requireGovtInfo =
      !fetchingStatus && myStatus && myStatus.requireGovtInfo;

    const hasUpcomingAppointment = !isEmpty(
      get(myStatus, 'upcomingAppointment'),
    );
    const postBookingOnboardingPending =
      hasUpcomingAppointment &&
      (requireLiabilityForm || requirePreferences || requireGovtInfo);

    const roadBlockedPages =
      isEmpty(untippedAppointments) &&
      !paymentFailedAppointments &&
      isEmpty(unReviewedAppointments) &&
      isEmpty(hasMembershipPaymentFailed) &&
      !postBookingOnboardingPending;

    const impersonateUserRoadBlockPages = !paymentFailedAppointments;
    isEmpty(hasMembershipPaymentFailed);

    const roadBlockPages = isImpersonateUser
      ? impersonateUserRoadBlockPages
      : roadBlockedPages;

    if (this.state.awaitingStatus) {
      const requestId = get(this.props, 'appointmentData.statusRequestId') || 0;
      const statusError = this.props.appointmentData.fetchingStatusError;
      const statusCheckFailed =
        requestId > this.state.baselineRequestId &&
        !fetchingStatus &&
        statusError;
      if (statusCheckFailed) {
        return (
          <div className="appWrap">
            <div
              className="MainContentWrap"
              style={{ textAlign: 'center', padding: '48px 20px' }}
            >
              <p>We couldn&apos;t verify your account before booking.</p>
              <button
                type="button"
                className="btn"
                onClick={() => this.props.fetchStatus(null, 'default')}
              >
                Try again
              </button>
            </div>
          </div>
        );
      }
      return <LoadingScreen hangTight="true" />;
    }

    if (fetchingStatus) {
      return <LoadingScreen hangTight="true" />;
    } else if (
      isImpersonateUser &&
      NOT_ALLOWED_ROUTES_IMPERSONATE_USER.includes(rest.path)
    ) {
      return <PageNotAllowed />;
    } else if (
      (!fetching && !userData.id) ||
      (!isEmpty(userData) && roadBlockPages)
    ) {
      return <Component {...propsData} />;
    }

    let redirectPath;
    if (paymentFailedAppointments) {
      redirectPath = '/appointment/payment-failed';
    } else if (!isEmpty(hasMembershipPaymentFailed)) {
      redirectPath = '/membership/payment-failed';
    } else if (!isEmpty(untippedAppointments)) {
      redirectPath = '/gratuity/tip';
    } else if (!isEmpty(unReviewedAppointments)) {
      redirectPath = '/gratuity/rate';
    } else if (postBookingOnboardingPending) {
      redirectPath = '/appointment/booked';
    }

    return (
      <Redirect
        to={{
          pathname: redirectPath,
          search: location.search,
          state: { from: this.props.location }, // eslint-disable-line react/prop-types
        }}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  appointmentData: makeSelectAppointment(),
  membershipData: makeSelectMembership(),
});

const withConnect = connect(
  mapStateToProps,
  { fetchStatus },
);

export default compose(
  withConnect,
  withRouter,
)(EligibleRoute);
